import form from './en/general/form.json';
import errors from './en/general/errors.json';

import list from './en/components/list.json';
import menu from './en/components/menu.json';
import modal from './en/components/modal.json';
import inputImage from './en/components/input-image.json';
import sidebar from './en/components/sidebar.json';

import checklists from './en/pages/checklists.json';
import countries from './en/pages/countries.json';
import infopages from './en/pages/infopages.json';
import login from './en/pages/login.json';
import logs from './en/pages/logs.json';
import pppelements from './en/pages/pppelements.json';
import statistics from './en/pages/statistics.json';
import usermanual from './en/pages/usermanual.json';
import notifications from './en/pages/notifications.json';

export default {
    general: {
        form,
        errors,
    },
    components: {
        list,
        menu,
        modal,
        input: {
            image: inputImage,
        },
        sidebar,
    },
    pages: {
        checklists,
        countries,
        infopages,
        login,
        logs,
        pppelements,
        statistics,
        usermanual,
        notifications,
    },
};
